import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import configs from 'configs';
import { canFullscreen, toggleFullScreen } from 'utils';

import ArrowCircleIcon from 'assets/icons/ArrowCircleIcon';
import GlobalIcon from 'assets/icons/GlobalIcon';
import { useNavigatedRoutes } from 'common/hooks';
import DPGallery from 'components/DPGallary';
import EtownGallary from 'components/EtownGallary';
import GalleryMenu from 'components/GalleryMenu';
import SchoolLayoutMenu from 'components/SchoolLayoutMenu';
import { useWorldActions } from 'components/World/hooks/useWorldActions';
import {
  AudioIcon,
  AutoRotateIcon,
  BackToDefaultSceneButton,
  ContactFormIcon,
  FloorMapIcon,
  FullScreenIcon,
  HelpIcon,
  MapFloorPlanIcon,
  MapIcon,
  PinIcon,
} from 'components/icons';
import { AutoPlayIcon } from 'components/icons/AutoPlayIcon';
import PanoMenu from 'components/panoMenu';
import { TOUR_ID } from 'consts/hardcoeRoute';
import { LAYOUT_UI } from 'consts/ui.const';
import { backToDefaultScene } from 'containers/world/utils';
import { useHistory } from 'react-router-dom';
import { setAutoPlay, updateWorldParams } from 'store/actions';
import { limitLetters } from 'utils/limitLetters';
import './DPstyles.scss';
import SchoolLayoutIcons from './SchoolLayoutIcons';
import SimpleLayoutIcons from './SimpleLayoutIcons';
import { ROUTE_MAP } from 'consts/url';
import DayTimeSwitch from 'components/DayTimeSwitch';
import { dayNightScene } from 'consts/dayNightScene';

const MenuForDesktop = (props) => {
  const {
    menuList,
    isNavOpen,
    menuPosition,
    currentPano,
    subTitle,
    menuOpenScene,
    toggleRotate,
    toggleMenu,
    shouldRotate,
    featuredMedia,
    color,
    isShowOnMap,
    isShowAudioIcon,
    isShowMapFloorPlan,
    floorMaps,
    tour,
    showLanding,
    groups,
    onSelect,
    scenes,
    openMenu,
    setOpenMenu,
    isAquaStyle,
    imageSize,
    setImageSize,
    tourGrounp,
  } = props;
  console.log(
    '🔍 ~  ~ src/components/MenuForDesktop/index.js:69 ~ tourGrounp:',
    tourGrounp
  );

  const history = useHistory();
  const [handleUpdateRoute] = useNavigatedRoutes();
  const [fullScreen, setFullScreen] = useState(false);

  const autoPlayMode = useSelector((state) => state.autoPlayMode);
  const [isAutoPlay, setIsAutoPlay] = useState(autoPlayMode);
  const [isActiveMap, setIsActiveMap] = useState(false);

  const [openDropDown, setOpenDropDown] = useState(false);
  const [mapShowed, setMapShowed] = useState();
  const [showAmenities, setShowAmenities] = useState(false);

  const { selectSceneById } = useWorldActions();

  const isVerticalImage = useMemo(
    () => imageSize.height > imageSize.width,
    [imageSize]
  );

  useEffect(() => {
    setOpenDropDown(false);
  }, [currentPano]);

  const isDPGrallery = true;
  const [activeMenuIndex, setActiveMenuIndex] = useState(0);

  const isMenuGallery = useSelector(
    ({ searchParams }) => searchParams['menu-ui'] === 'gallery'
  );

  const shouldShowMapIcon = useMemo(
    () =>
      tour.mapCoordinates.length > 0 &&
      !(tour.mapCoordinates[0] === 0 && tour.mapCoordinates[1] === 0),
    [tour]
  );

  const isSchoolLayout = useMemo(
    () => tour.menuStyle === LAYOUT_UI.SCHOOL,
    [tour]
  );

  const isBothersFurnitureLayout = useMemo(
    () => tour.menuStyle === LAYOUT_UI.BROTHERS_FURNITURE,
    [tour]
  );

  const isSimpleLayout = useMemo(
    () => tour.menuStyle === LAYOUT_UI.SIMPLE,
    [tour]
  );

  const toggleHelpButton = () => {
    showLanding();
  };

  const handleFullScreen = () => {
    toggleFullScreen();
    setFullScreen(!fullScreen);
  };

  const dispatch = useDispatch();

  const switchMode = useCallback(() => {
    setIsAutoPlay(!isAutoPlay);
    dispatch(setAutoPlay(!isAutoPlay));
  }, [dispatch, isAutoPlay]);

  const handleOpenMenu = () => {
    setOpenMenu(!openMenu);
  };

  useEffect(() => {
    if (window.location.pathname === `/${ROUTE_MAP.amenities.id}`) {
      setShowAmenities(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.pathname]);

  useEffect(() => {
    if (floorMaps.length > 0 && currentPano) {
      const getLinkedFloorPlanFromOtherScene = (floorMaps, pano) => {
        return floorMaps.find((item) =>
          item.objects.length
            ? item.objects.some((obj) => obj.id === pano._id)
            : item
        );
      };

      const linkedFloorPlan = getLinkedFloorPlanFromOtherScene(
        floorMaps,
        currentPano
      );
      if (linkedFloorPlan) {
        setMapShowed(linkedFloorPlan);
      } else {
        setMapShowed(floorMaps[0]);
      }
    }
  }, [currentPano, floorMaps]);

  const handleSelectMap = (item) => {
    setMapShowed(item);
  };

  const isDocumentsTab = useMemo(() => {
    return (
      menuList[activeMenuIndex]?.name?.toLowerCase?.().includes('gallery') &&
      history.push('/gallery')
    );
  }, [menuList, activeMenuIndex, history]);

  const isGalleryTab = useMemo(() => {
    const pathname = window.location.pathname;
    return pathname === '/gallery' || pathname.startsWith('/gallery/');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.pathname]);

  const amenitiesMenu = useMemo(() => {
    return menuList?.find?.((item) =>
      item?.name?.toLowerCase?.().includes('amenities')
    );
  }, [menuList]);

  // Filter out GALLERY
  const filteredMenuList = useMemo(() => {
    return menuList?.filter?.(
      (item) => item?.name?.toLowerCase?.() !== 'gallery'
    ) || [];
  }, [menuList]);

  if (isDPGrallery) {
    return (
      <div className="dp-gallery-container">
        <div className="dp-gallery-option">
          <ul>
            <li
              className="dp-gallery-option-map-button"
              onClick={() => {
                history.push(`/map`);
              }}
            >
              <span className="dp-gallery-option-title">Map</span>
            </li>
            {filteredMenuList.map((item, index) => {
              const lastIndex = filteredMenuList.length - 1;
              const isAmenities = item.name.toLowerCase().includes('amenities');

              // 2. Tạo biến isLast (hoặc isLasted)
              const isLasted = index === lastIndex && !isAmenities;
              return (
                <li
                  key={item.id}
                  onClick={() => {
                    if (isAmenities) {
                      history.push(`/${ROUTE_MAP.amenities.id}`);
                      setShowAmenities(true);
                      setActiveMenuIndex(index);
                    } else if (isLasted) {
                      setActiveMenuIndex(index);
                      dispatch(
                        updateWorldParams({
                          tourId: TOUR_ID,
                          documentRoute: 'documents',
                          sceneId: '',
                          groupId: '',
                          hotspotId: '',
                        })
                      );
                      setShowAmenities(false);
                    }
                  }}
                  className={`${
                    isDocumentsTab && activeMenuIndex === index && 'active'
                  }`}
                >
                  <span className="dp-gallery-option-title">
                    {item.name === 'Tài Liệu' ? 'Tài liệu' : item.name}
                    {!isLasted && !isAmenities && (
                      <ArrowCircleIcon color="black" height={15} width={15} />
                    )}
                  </span>

                  {!isAmenities && (
                    <div className={`option`}>
                      {item.scenes.map((scene) => (
                        <div
                          key={scene.id}
                          onClick={() => {
                            setActiveMenuIndex(index);
                            selectSceneById(groups[0].id, scene._id);
                            setShowAmenities(false);
                          }}
                        >
                          <span
                            className={`${
                              scene.id === currentPano?.friendlyName
                                ? 'active'
                                : ''
                            }`}
                          >
                            {scene.title}
                          </span>
                        </div>
                      ))}
                    </div>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
        {/* Documents grid when 'Tài liệu' tab selected */}
        {isGalleryTab && <DPGallery items={[]} />}
        {showAmenities && (
          <EtownGallary
            items={
              amenitiesMenu?.scenes?.map?.((scene) => ({
                id: scene._id,
                title: scene.title,
                coverImage: scenes.find((s) => s._id === scene._id)
                  ?.previewImgUrl,
                tourGroupName: tourGrounp.find(
                  (g) =>
                    g._id === scenes.find((s) => s._id === scene._id)?.tourGroupId
                )?.title,
              })) || []
            }
            onClose={() => setShowAmenities(false)}
          />
        )}
        {/* {isDocumentsTab && <DPDocuments items={galleryItems} />} */}

        <div className="dp-button-container">
          {/* <div className="map_floor_plan_btn-container">
            <button
              className={`button ${isActiveMap ? 'active' : ''}`}
              onClick={() => setIsActiveMap(!isActiveMap)}
            >
              {!isActiveMap ? (
                <MapFloorPlanIconDP color="black" height={20} width={20} />
              ) : (
                <CloseIcon color="white" width={20} height={20} />
              )}
            </button>
            <MapFloorPlanComponent
              isActiveMap={isActiveMap}
              isVerticalImage={isVerticalImage}
              mapShowed={mapShowed}
              floorMaps={floorMaps}
              setOpenDropDown={setOpenDropDown}
              openDropDown={openDropDown}
              limitLetters={limitLetters}
              onSelect={onSelect}
              scenes={scenes}
              currentPano={currentPano}
              handleSelectMap={handleSelectMap}
              setImageSize={setImageSize}
              className={'dp_map'}
            />
          </div> */}

          <div className="dp-social-button">
            <button className="button">
              <GlobalIcon color="black" width={20} height={20} />

              <ul className="social-list">
                {['youtube', 'tik-tok', 'facebook'].map((item) => (
                  <li key={item}>
                    <a href={`https://www.${item}.com`}>
                      <img
                        src={`/assets/images/social/${item}.png`}
                        alt={item}
                      />
                    </a>
                  </li>
                ))}
              </ul>
            </button>
          </div>
        </div>
        <div className="dp-logo">
          <img src="/assets/images/logo/etown_logo.png" alt="logo" />
        </div>
        {dayNightScene.includes(currentPano?._id) && (
          <DayTimeSwitch
            currentPano={currentPano}
            selectSceneById={selectSceneById}
          />
        )}
      </div>
    );
  }

  return (
    <div className={`menuV2-desktop--container`}>
      {isMenuGallery && (
        <GalleryMenu
          scenes={scenes}
          desktop={true}
          groups={groups}
          onSelect={onSelect}
          activeColor={color}
          currentPano={currentPano}
          openMenu={openMenu}
          handleOpenMenu={handleOpenMenu}
        />
      )}

      {isSchoolLayout && (
        <SchoolLayoutMenu
          menuList={filteredMenuList}
          scenes={scenes}
          desktop={true}
          groups={groups}
          onSelect={onSelect}
          activeColor={color}
          currentPano={currentPano}
          openMenu={openMenu}
          handleOpenMenu={handleOpenMenu}
          isSchoolLayout={isSchoolLayout}
        />
      )}

      <div
        className={`menuV2-desktop--container_left ${
          isMenuGallery
            ? `container-width ${!openMenu && 'container-width-closed'}`
            : ''
        } ${isSimpleLayout ? 'hide-menu' : ''}`}
      >
        <div>
          {!isMenuGallery && !isSchoolLayout && (
            <div
              className="header"
              onClick={() => toggleMenu(tour.isPublic ? false : !isNavOpen)}
              style={{ cursor: ` ${tour.isPublic ? 'default' : 'pointer'}` }}
            >
              <div className="header_icon">
                <PinIcon color={color} />
              </div>
              <div className="header_titles">
                <div className="header_titles_title" style={{ color }}>
                  {currentPano ? limitLetters(currentPano.title, 100) : null}
                </div>
                <p className="header_titles_label">{subTitle || null}</p>
              </div>
            </div>
          )}
          <PanoMenu
            isOpen={isNavOpen}
            menu={filteredMenuList}
            location={menuPosition}
            onClose={() => toggleMenu(false)}
            onSelect={menuOpenScene}
            color={color}
          />
        </div>
      </div>
      <div className="menuV2-desktop--container_right">
        <div
          className={`icons_left ${
            isMenuGallery && !openMenu ? 'margin-left__0' : ''
          }`}
        >
          {shouldShowMapIcon && (
            <div
              className="icon"
              style={{
                display: isShowOnMap ? 'flex' : 'none',
              }}
              onClick={() => handleUpdateRoute(configs.mapRoute)}
            >
              <MapIcon />
            </div>
          )}
        </div>
        {isSchoolLayout && (
          <SchoolLayoutIcons
            currentPano={currentPano}
            isAutoPlay={isAutoPlay}
            color={color}
            toggleHelpButton={toggleHelpButton}
            featuredMedia={featuredMedia}
            isShowAudioIcon={isShowAudioIcon}
            toggleRotate={toggleRotate}
            shouldRotate={shouldRotate}
            canFullscreen={canFullscreen}
            menuPosition={menuPosition}
            handleFullScreen={handleFullScreen}
            fullScreen={fullScreen}
            isShowMapFloorPlan={isShowMapFloorPlan}
            setIsActiveMap={setIsActiveMap}
            isActiveMap={isActiveMap}
            mapShowed={mapShowed}
            setOpenDropDown={setOpenDropDown}
            openDropDown={openDropDown}
            handleSelectMap={handleSelectMap}
            scenes={scenes}
            onSelect={onSelect}
            switchMode={switchMode}
            handleUpdateRoute={handleUpdateRoute}
            isSchoolLayout={isSchoolLayout}
            isAquaStyle={isAquaStyle}
          />
        )}

        {isSimpleLayout && (
          <SimpleLayoutIcons
            currentPano={currentPano}
            isAutoPlay={isAutoPlay}
            color={color}
            toggleHelpButton={toggleHelpButton}
            featuredMedia={featuredMedia}
            isShowAudioIcon={isShowAudioIcon}
            toggleRotate={toggleRotate}
            shouldRotate={shouldRotate}
            canFullscreen={canFullscreen}
            menuPosition={menuPosition}
            handleFullScreen={handleFullScreen}
            fullScreen={fullScreen}
            isShowMapFloorPlan={isShowMapFloorPlan}
            setIsActiveMap={setIsActiveMap}
            isActiveMap={isActiveMap}
            mapShowed={mapShowed}
            setOpenDropDown={setOpenDropDown}
            openDropDown={openDropDown}
            handleSelectMap={handleSelectMap}
            scenes={scenes}
            onSelect={onSelect}
            switchMode={switchMode}
            handleUpdateRoute={handleUpdateRoute}
            isSchoolLayout={isSchoolLayout}
            isAquaStyle={isAquaStyle}
            floorMaps={floorMaps}
            isSimpleLayout={isSimpleLayout}
          />
        )}

        {!isSchoolLayout && !isSimpleLayout && (
          <div className="icons_right">
            {isBothersFurnitureLayout && (
              <div
                className={`icon`}
                onClick={() => backToDefaultScene(filteredMenuList, scenes, onSelect)}
              >
                <BackToDefaultSceneButton
                  menuList={filteredMenuList}
                  currentPano={currentPano}
                />
              </div>
            )}

            {shouldShowMapIcon && (
              <div
                className={`icon`}
                style={{
                  display: isShowOnMap ? 'flex' : 'none',
                }}
                onClick={() => handleUpdateRoute(configs.mapRoute)}
              >
                <MapIcon />
              </div>
            )}

            <div className={`icon`} onClick={() => switchMode()}>
              <AutoPlayIcon shouldRotate={isAutoPlay} activeColor={color} />
            </div>

            <div className={`icon`} onClick={toggleHelpButton}>
              <HelpIcon />
            </div>
            {featuredMedia.map && (
              <div
                className={`icon`}
                onClick={() => handleUpdateRoute(featuredMedia.map.id)}
              >
                <FloorMapIcon />
              </div>
            )}
            {featuredMedia.contact && (
              <div
                className={`icon`}
                onClick={() => handleUpdateRoute(featuredMedia.contact.id)}
              >
                <ContactFormIcon />
              </div>
            )}
            {isShowAudioIcon && (
              <AudioIcon activeColor={color} className={`icon`} />
            )}
            <div
              className={`icon`}
              onClick={() => {
                toggleRotate();
              }}
            >
              <AutoRotateIcon shouldRotate={shouldRotate} activeColor={color} />
            </div>
            {canFullscreen() && menuPosition !== 'bottom' && (
              <div className={`icon`} onClick={handleFullScreen}>
                <FullScreenIcon fullScreen={fullScreen} activeColor={color} />
              </div>
            )}
            {isShowMapFloorPlan && (
              <>
                <div
                  className={`icon position-relative`}
                  onClick={() => setIsActiveMap(!isActiveMap)}
                >
                  <MapFloorPlanIcon active={isActiveMap} />
                </div>
                <div
                  className={`mapfloorplan_container ${
                    isActiveMap
                      ? `open ${isVerticalImage ? 'open-vertical--image' : ''}`
                      : ''
                  }`}
                >
                  {mapShowed && (
                    <>
                      {floorMaps?.length > 1 && (
                        <div className="map_header">
                          <div
                            className="map_dropdown"
                            onClick={() => setOpenDropDown(!openDropDown)}
                          >
                            <span>
                              {limitLetters(mapShowed.image.name, 15)}
                            </span>
                            <i className="map_arrow down"></i>
                            {openDropDown && (
                              <div
                                className={`map_dropdown_options ${
                                  openDropDown ? 'show' : ''
                                }`}
                              >
                                <ul className="dropdown_items">
                                  {floorMaps?.map((item, index) => (
                                    <li
                                      onClick={() => handleSelectMap(item)}
                                      key={index}
                                    >
                                      {limitLetters(item.image.name, 10)}
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      <div className="map_image">
                        <img
                          src={mapShowed.image.url}
                          alt={mapShowed.image.name}
                          onLoad={(e) =>
                            setImageSize({
                              width: e.target.naturalWidth,
                              height: e.target.naturalHeight,
                            })
                          }
                        />
                        {mapShowed.objects.map((viewpoint) => {
                          const currentPoint = viewpoint.id === currentPano._id;
                          const [left, top] = viewpoint.coordinates;
                          const leftInPercent = left * 100;
                          const topInPercent = top * 100;
                          const currentScene =
                            scenes.find((s) => s._id === viewpoint.id) || {};

                          return (
                            <div
                              key={viewpoint.id}
                              className={`viewpoint-container ${
                                currentPoint ? 'current-viewpoint' : 'viewpoint'
                              } `}
                              style={{
                                left: `${leftInPercent}%`,
                                top: `${topInPercent}%`,
                              }}
                              onClick={() =>
                                onSelect(currentScene.groupId, currentScene.id)
                              }
                            >
                              <p className="scene-title">
                                {currentScene.title}
                              </p>
                            </div>
                          );
                        })}
                      </div>
                    </>
                  )}
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default MenuForDesktop;
